module.exports = __webpack_public_path__ + "assets/img/help.cb291a83.png";